import gql from "graphql-tag";

export const list = gql`
  query ActivityLog($limit: Int) {
    activityLog(limit: $limit) {
      id
      at
      user_email
      operation
      detail
    }
  }
`;
